import React from "react";
import { cn } from "@gettactic/helpers";

export interface WizardReviewTextProps {
  label: string;
  value?: string | null;
  className?: string;
}

/** A label over a longer text; renders nothing without a value. */
export const WizardReviewText: React.FC<WizardReviewTextProps> = ({
  label,
  value,
  className
}) => {
  if (!value) return null;

  return (
    <div className={className}>
      <span className="text-sm text-content">{label}</span>
      <p className="mt-1 text-sm text-neutral-900">{value}</p>
    </div>
  );
};
